import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Accordion from 'react-bootstrap/Accordion'
import Table from 'react-bootstrap/Table'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import Modal from 'react-bootstrap/Modal'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Spinner from 'react-bootstrap/Spinner';
import { FiCopy } from "react-icons/fi";
import { useState } from "react";
import { FiEdit, FiUsers } from 'react-icons/fi'
import { useNavigate, useLocation } from "react-router-dom";
import './index.css'
import { GetLeaguesByIds, GetUser, GetLeagues, GetTeamRiders, GetNextEvent, GetLeaderboard, GetResultsForTeam, LeaveLeague, GetDisabled } from '../../ApiRequests'
import Helmet from 'react-helmet'


const League = (props) => {

    const URL = process.env.REACT_APP_FRONT_END_URL


    const location = useLocation()
    const navigate = useNavigate()
    const params = new URLSearchParams(location.search);
    const _leagueId = params.get('leagueId');

    const [leagueId, setLeagueId] = useState([])
    const [league, setLeague] = useState({})
    const [user, setUser] = useState({})
    const [userIds, setUserIds] = useState([])
    const [riders, setRiders] = useState([])
    const [team, setTeam] = useState({})
    const [nextEvent, setNextEvent] = useState({})
    const [leaderboard, setLeaderboard] = useState([])
    const [copied, setCopied] = useState(false)
    const [share, setShare] = useState(false)
    const [notInLeague, setNotInLeague] = useState(false)
    const [showBreakdown, setShowBreakdown] = useState(false)
    const [currentPosition, setCurrentPosition] = useState(0)
    const [breakdownTeam, setBreakdownTeam] = useState({})
    const [showLeaveLeague, setShowLeaveLeague] = useState(false)
    const [editingDisabled, setEditingDisabled] = useState(true)


    
    const getLeague = async () => {
        setLeagueId(_leagueId)
        const leagueInfo = await GetLeaguesByIds([_leagueId])

        if (!leagueInfo) { return }
        if (!'data' in leagueInfo) {
            console.log('no data found')
            return
        }
        setLeague(leagueInfo.data[0])
    }

    const getLeaderboard = async () => {
        try {
            const _userId = localStorage.getItem('userID')
            const _leaderboard = await GetLeaderboard(_leagueId)
            if (!leaderboard || !'data' in leaderboard) { return }
            if (!_leaderboard.data) { return }
            setLeaderboard(_leaderboard.data.teams)
            // const _sorted = _leaderboard.data.sort((a, b) = b.total_points - a.total_points)
            const currentPosition = _leaderboard.data.teams.findIndex((team) => team.userId === _userId);
            setCurrentPosition(currentPosition + 1);

        } catch (error) {
            console.log(error)
        }
    }

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data){
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const userData = await GetUser(userId)

        if (!userData) { return }
        if ('data' in userData) {
            setUser(userData.data)
            getUserRiders(userData.data)
        } else {
            console.log('user has no data')
            return null
        }
    }

    const getUserRiders = async (_user) => {
        if (!_user) { return }
        if (!'teams' in _user) { return }

        const _team = _user.teams.find(team => team.leagueId == _leagueId)
        if (!_team) {
            setNotInLeague(true)
            navigate(`/CreateTeam?leagueId=${leagueId}`)
            return
        }

        setTeam(_team)
        const _riders = await GetTeamRiders(_team.teamId)
        if (!_riders) { return }
        setRiders(_riders.data)
    }

    const getUserIds = (leagueInput) => {
        const data = leagueInput.teams.map(team => team.userId)

        setUserIds(data)
    }

    const copyURL = async (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 5000);
            })
            .catch((error) => {
                console.error('Failed to copy URL:', error);
            });

    }


    const editMyTeam = () => {
        if (team && 'teamId' in team && leagueId) {
            navigate(`/EditTeam?teamId=${team.teamId}&leagueId=${leagueId}`)
        }
    }

    const getNextEvent = async () => {
        const res = await GetNextEvent()
        if (!res) { return }
        setNextEvent(res.data)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${year}-${month}-${day}`;
    }

    const handleGetBreakdown = async (_team) => {
        const res = await GetResultsForTeam(_team.teamId)

        if (!res || !res.data) { return }

        setBreakdownTeam(res.data)
    }

    const handleLeaveLeague = async () => {
        const userId = localStorage.getItem('userID')
        const res = await LeaveLeague(leagueId, userId, team.teamId)

        if (res.status != 200) { return }

        setShowLeaveLeague(false)
        navigate('/')
    }


    useEffect(() => {
        getLeague()
        getUser()
        getNextEvent()
        getLeaderboard()
        getEditingDisabled()
    }, [])



    const renderLeaderboard = (_team, index) => {
        return (
            <tr key={index}>
                <td>{index + 1}</td>
                <td style={{ maxWidth: '200px', overflowX: 'auto' }}>{_team.userName}</td>
                <td style={{minWidth: '220px'}}className="d-flex justify-content-between">{_team.totalPoints}
                    <Button variant='outline-secondary fw-light my-0 py-0' onClick={() => { setShowBreakdown(true); handleGetBreakdown(_team) }}>View Breakdown</Button>
                </td>
            </tr>
        )
    }




    const renderBreakdown = (_event, index) => {

        return (
            <Tab eventKey={_event.location} title={_event.location}>
                {Array.isArray(_event.riders) && _event.riders.map(renderRidersBreakdown)}
                <Tabs
                    defaultActiveKey='Overall'
                    id="uncontrolled-tab-example"
                    className="mb-3 mt-4"
                    onSelect={(e) => console.log(e)}
                >
                    <Tab eventKey="Overall" title="Overall">
                        <Table responsive="sm" striped bordered hover className="px-5">
                            <thead>
                                <tr>
                                    <th>Place</th>
                                    <th>Name</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(_event.results) && _event.results.map((result, index) => renderResults(result, index, 'Overall'))}
                            </tbody>
                        </Table>

                    </Tab>
                    <Tab eventKey="Qualifying" title="Qualifying">
                        <Table responsive="sm" striped bordered hover className="px-5">
                            <thead>
                                <tr>
                                    <th>Place</th>
                                    <th>Name</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(_event.results) && _event.results.map((result, index) => renderResults(result, index, 'Qualifying'))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="Semis" title="Semi Finals">
                        <Table responsive="sm" striped bordered hover className="px-5">
                            <thead>
                                <tr>
                                    <th>Place</th>
                                    <th>Name</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(_event.results) && _event.results.map((result, index) => renderResults(result, index, 'Semis'))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="Finals" title="Finals">
                        <Table responsive="sm" striped bordered hover className="px-5">
                            <thead>
                                <tr>
                                    <th>Place</th>
                                    <th>Name</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(_event.results) && _event.results.map((result, index) => renderResults(result, index, 'Finals'))}
                            </tbody>
                        </Table>
                    </Tab>
                </Tabs>
            </Tab>
        )
    }

    const renderResults = (result, index, type) => {
        return (
            <>
                {

                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{result.rider_first_name} <b>{result.rider_last_name}</b> ({result.rider_gender})</td>
                        {type == 'Overall' && <td className="d-flex justify-content-between">{result.total_points}</td>}
                        {type == 'Qualifying' && <td className="d-flex justify-content-between">{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between">{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between">{result.finals_points}</td>}
                    </tr>
                }
            </>
        )
    }


    const renderRidersBreakdown = (rider, index) => {
        return (
            <div>
                <Card key='index' className="my-2" bg='light' >
                    <Card.Body className="py-2">
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name} <span className="fw-light fs-6 ms-1">({rider.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center justify-content-md-end fw-light">${(rider.value * 50000).toLocaleString()}</div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const renderRiders = (rider, index) => {
        return (
            <div>
                <Card key='index' className="my-2" bg='light' >
                    <Card.Body>
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name} <span className="fw-light fs-6 ms-1">({rider.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider.team}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center justify-content-md-end fw-light">${(rider.value * 50000).toLocaleString()}</div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <div className="container pt-3" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            <Helmet>
                <title>League - Downhill MTB Fantasy</title>
                <meta name="description" content="Explore the details and standings of a specific downhill mountain biking league. Compete with other participants and track your performance." />
            </Helmet>
            <div className="mt-2 mx-sm-0 mx-2 d-flex flex-row justify-content-sm-center fw-bold fs-4 ">{league?.name}</div>
            <div className="mb-2 mx-sm-0 mx-2 d-flex flex-row justify-content-sm-center fw-light fs-6 ">{league?.description}</div>
            <div className="mx-sm-4 mx-2 py-3 pt-5">

                <div className="row">
                    <div className="col-md-8">
                        {/* <div className="fw-bold fs-5 mx-2">{league.name}</div>
                        <div className="fw mx-2">{league.description}</div> */}
                        <div className="fw-light mx-2">Male Riders per team: {league?.numberMaleRiders == null ? 4 : league?.numberMaleRiders}</div>
                        <div className="fw-light mx-2 mb-1">Female Riders per team: {league?.numberFemaleRiders == null ? 2 : league?.numberFemaleRiders}</div>
                        <Button disabled={editingDisabled} variant="primary" className="my-2 px-5" onClick={() => editMyTeam()}><FiEdit size={18} className="mb-1 me-2"></FiEdit>Edit My Team</Button>
                        <div className="mb-md-0 mb-3">
                            <Button variant="outline-secondary" className=" px-5" onClick={() => setShare(!share)}><FiUsers size={18} className="mb-1 me-2"></FiUsers>Invite Friends</Button>
                        </div>

                        {league && share &&
                            <div className="my-2">
                                <Form.Label className="mt-1 fw-bold">League Url:</Form.Label>
                                <div className="row">
                                    <div className="col-md"> <Form.Control disabled type='text' className='fw-light' readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                    <div className="col-md-2 p-0">
                                        <Button variant='secondary' onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}>Copy URL</Button>
                                    </div>
                                </div>
                            </div>}
                    </div>
                    <div className="col-md-4">
                        <div className="mx-2 fw-light">Next Event: {formatDate(nextEvent.date)}</div>
                        <div className="mx-2 fw-light">Current League Leader: <b>{Array.isArray(leaderboard) && leaderboard[0]?.userName}</b></div>
                        <div className="mx-2 fw-light">Your current position: <b>{currentPosition}</b></div>

                    </div>
                </div>
            </div>
            <hr></hr>
            <Accordion className="mx-2" style={{ width: '', minWidth: '350px', maxWidth: '800px' }}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>LeaderBoard {leaderboard?.length ? `(${leaderboard?.length})` : <Spinner className="ms-3" size='sm'></Spinner>}</Accordion.Header>
                    <Accordion.Body>
                        {!leaderboard?.length || leaderboard?.length == 0 ?
                            <Spinner></Spinner>
                            :
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {leaderboard.map(renderLeaderboard)}  */}
                                    {Array.isArray(leaderboard) && leaderboard.map(renderLeaderboard)}
                                </tbody>
                            </Table>}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <div className="px-2 py-4">
                <div className="fs-5 mx-4 fw-bold">My Team</div>
                {
                    !riders || riders?.length == 0 &&
                    <div className="mt-3 ms-5">
                        <Spinner size="lg"></Spinner>
                    </div>

                }
                {Array.isArray(riders) && riders.map(renderRiders)}
            </div>

            {
                 riders?.length != 0 &&
                <div className="d-flex justify-content-center">
                    <Button variant='outline-danger' onClick={() => setShowLeaveLeague(true)}>Leave League</Button>
                </div>

            }


            <div className="" style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: '9999',
            }}>
                <Alert variant="success" show={copied} sticky='top' onClose={() => setCopied(false)} dismissible>
                    League URL copied to clipboard!
                </Alert>
            </div>

            <Modal size='lg' show={showBreakdown} onHide={() => setShowBreakdown(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Points Breakdown: {breakdownTeam.userName}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fw-light">
                    <Tabs
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={(e) => console.log(e)}
                    >
                        {Array.isArray(breakdownTeam.results) && breakdownTeam.results.map(renderBreakdown)}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowBreakdown(false); setBreakdownTeam({}) }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='md' show={showLeaveLeague} onHide={() => setShowLeaveLeague(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure?</Modal.Title>
                </Modal.Header>
                <Modal.Body className="fw-light">
                    If you leave this league, your team will be permanently deleted and cannot be recovered.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowLeaveLeague(false) }}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => { handleLeaveLeague() }}>
                        Leave League
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default League;